import { gql } from '@apollo/client';

export const GET_DRIVER_SMS = gql`
    query GetDriverSms($driverId: Long!, $trackingNumber: String!,$language :String!) {
        getDriverSms(driverId: $driverId, trackingNumber: $trackingNumber,language: $language) {
            details {
                message
                roleType
                createdAt
                status
                recordId
            }
        }
    }
`;

export interface DriverSmsThreadDetail {
    message: string;
    roleType: number;
    createdAt: number | null;
    status: string;
    recordId: number;
}

export interface DriverSmsResponse {
    getDriverSms: {
        details: DriverSmsThreadDetail[];
    } | null;
}

export interface DriverSmsVariables {
    driverId: number;
    trackingNumber: string;
    language: string;
}


